export default function EnumHelperService() {

  function getKeyByValue<E extends Object, V>(_enums: E, value: V) {
    return Object.keys(_enums).find(
      key => _enums[key as keyof E] === value
    );
  }

  function getValueByKey<E extends Object>(_enums: E, key: string) {
    // let keyIndex = Object.keys(_enums).indexOf(key);
    return _enums[key as keyof E];
  }

  function extractEnumKeys<E extends Object>(enums: E) {
    return Object.keys(enums);
  };

  function extractEnumValues<E extends Object>(enums: E) {
    return Object.values(enums);
  };

  function extractEnumEntries<E extends Object>(enums: E) {
    return Object.entries(enums);
  };

  // ---
  return {
    getKeyByValue, getValueByKey,
    extractEnumValues,
    extractEnumKeys,
    extractEnumEntries,
  }
}